import ReactDOM from "react-dom";

/**
 * Renders children into the widget's own mount node.
 *
 * The React app is mounted once into <div id="root">, which Allied_Master.cshtml
 * emits immediately after <body> - ABOVE the site header. A widget that renders
 * inline therefore appears at the top of the page rather than where the content
 * editor placed it.
 *
 * The original OnlineBooking component solves this by scattering seven
 * ReactDOM.createPortal calls through its render method. This wrapper does the
 * same relocation once, at the mount boundary, so widget components stay pure
 * and testable without needing a DOM mount point to exist.
 *
 * Returns null rather than throwing when the target is missing, so a page that
 * loads the bundle without hosting the widget renders nothing.
 */
const WidgetPortal = ({ target, children }) => {
  if (!target) return null;
  return ReactDOM.createPortal(children, target);
};

export default WidgetPortal;
